/**
 * Normally we would link to the terms and conditions pages on Eikaiwa/Engoo,
 * but Korean government rules require the terms and conditions to be displayed
 * inline on the signup form itself. This is why these strings are checked into
 * the Replace codebase.
 *
 * Additionally, because this requirement is only for Korea, these strings do
 * not need to be translated, which is why they are hard-coded strings instead
 * of being stored with the locale strings.
 */
/* eslint-disable max-len, no-trailing-spaces */
export const KoreanTermsGeneral = `**제 1조 (일반 규정)**

1. ENGOO 서비스 이용 약관은 (이하 “이용 약관”이라 합니다.) DMM.com Co., ltd에서 제공하는 ENGOO 온라인 영어회화 서비스의 (이하 “서비스”라 합니다.)이용과 관련한 사항을 규정합니다. 본 이용 약관의 범위에는 회사의 이용 약관,이외 표준 이용 약관뿐만 아니라 회사가 규정한 모든 회원 계약이 포함됩니다.

2. 약관 페이지 외의 홈페이지 내의 도움말 페이지 및 가이드 페이지들도 본 이용 약관의 범위에 포함됩니다.

3. 사용자는 이용 약관에 동의한다는 의사를 표시한 후 서비스를 이용할 수 있습니다. 또한, 회사는 이용 약관을 개정할 경우 개정된 이용 약관을 적용하는 날로부터 7일 이전에, 사용자에게 불리하게 약관 내용이 변경되는 경우에는 30일 이전에 사용자에게 고지 또는 전자메일로 통보합니다. 이용 약관에 대한 모든 개정은 그들이 서비스에 게시되는 순간부터 적용되는 것으로 간주됩니다. 개정이 이루어진 후 사용자들이 7일 이내에 계약해지의 의사표시를 하지 않고 서비스를 사용할 경우, 사용자들은 새로 개정된 약관에 동의한 것으로 간주됩니다.

4. 회사는 기록과 의견, 대화, 문의를 저장하고 합리적으로 서비스를 관리하기 위한 목적으로 필요한 서비스 내에서 정보를 게시할 수 있습니다. 필요하다고 인정되는 경우, 회사는 영상 및 이미지들을 수집할 수 있습니다. 회사는 이러한 정보들을 서비스의 적절한 운영에 필요할 경우에만 불가피한 이유로 최소한의 정보만을 사용할 것입니다. 회원들은 또한, 회사의 이러한 방침에도 동의하는 것으로 간주됩니다.

**제 2조 (이용 약관의 적용)**

1. 이 약관은 회사가 회사의 응용 프로그램, 전자 메일을 통해 사용자들에게 회사의 전송서비스를 제공할 수 있음을 명시합니다.

2. 이용 약관 이외의 별도의 합의를 (이하 “별도 협정”이라 합니다.) 하는 경우,기존의 회사와 회원 사이에 명시된 규정들보다 별도의 협의가 명시하는 규정들에 우선 순위를 부여합니다.

**제 3조 (서비스 등록 신청)**

1. 사용자는 회사가 설정한 별도의 방법을 통하여 서비스에 등록할 수 있습니다.또한, 서비스 등록을 신청할 때 사용자는 다음과 같은 조항에 동의하고 준수해야 합니다:

  (1) 사용자는 본인의 통신 환경을 서비스 이용에 방해되지 않도록 설정해야 합니다.

  (2) 미성년자인 사용자들은 서비스 이용에 앞서 부모 또는 보호자와 같은 자신의 법정 대리인의 동의를 받아야 합니다.

  (3) 사용자는 서비스에 대한 사용 비용을 지불 약관 제 7조에서 규정하고 있는 결제 방법을 통하여 납부해야 합니다.

  (4) 수업을 제공하는 사람들은 풀타임 및 회사/회사의 하청 업체의 파트 타임 직원을 포함합니다. (이하 “교사(들)”이라 합니다.)

  (5) 회사는 통지, 광고, 설문 조사 및 사용자들에게 서비스에 대한 기타 유사한 정보를 보낼 전자 메일 정보를 사용할 수 있습니다.

2. 서비스를 이용하기 위한 회원등록은 회사가 발송하는 계정 인증 전자 메일을 통한 본인 인증이 완료된 것으로 간주합니다.

3. 사용자가 아래 각 호의 어느 하나에 해당하는 경우, 회사는 회원의 등록이 완료됐다 하더라도 사용자의 등록을 거부 혹은 취소할 수 있습니다.

  (1) 신청자가 실제로 존재하지 않는 것으로 간주되는 경우

  (2) 회원 등록 시, 혹은 과거에 해당 회원이 이용 약관의 위반을 통해 계정이 정지되었거나, 회원 등록 철회가 이루어졌던 경우

  (3) 사용자의 신청 정보가 거짓, 불명확 또는 불완전한 정보를 포함하고 있을 경우

  (4) 신청 시, 혹은 과거에 해당 사용자가 서비스 이용 요금 지불을 방치했을 경우

  (5) 회사가 지정한 결제 서비스 회사가 해당 신청자와의 계약 체결을 거부했을 경우

  (6) 동일 인물이 계정을 복수로 생성한 경우

  (7) 본사에 의해 적절하지 않다고 판단되는 경우

4. 등록이 완료된 경우, 제 7조에 의해 이용 요금에 대한 첫 번째 지불이 회사에 의해 확인된 경우, (이하 “사용 시작 날짜” 라고 합니다.) 사용자는 당일에 회사의 시스템을 통하여 서비스의 사용을 시작할 수 있어야 합니다. 제 8조에 의해 무료 체험 회원은 적용되지 않습니다.

**제 4조 (등록 정보의 취급)**

1. 기업은 서비스를 제공할 목적으로 사용자들로부터 수집된 정보를 사용할 수 있습니다.

2. 사용자에게 서비스를 제공하기 위하여, 기업은 일부 서비스를 위임한 제3자에게 다음의 사용자 등록 정보를 제공할 수 있습니다.

  (1) 성명

  (2) 성별

3. 앞의 절에 지정된 경우와 다음 경우에 해당되는 경우를 제외하고, 회사는 제3자에게 사용자의 사전 승인 없이 사용자의 등록 정보를 공개하지 않습니다.

  (1) 법에 의해 정보를 공개하도록 요청 받은 경우

  (2) 정보를 공개하기를 거부한 것이 공공의 이익에 반하는 경우, 사용자의 사전 동의를 얻기가 어려운 경우

  (3) 법을 준수하기 위해 국가 기관 또는 지방 공공단체, 또는 하청 업체와 협력이 필요하거나 회원의 동의를 구하기 위해 연락하는 것이 법 준수를 방해할 때

  (4) 회사의 정당한 권리를 행사하기 위해 필요한 경우

4. 이 이용 약관에서 규정되지 않은 사용자의 등록 정보 취급에 관한 건은 회사의 개인정보 처리방침에 정의되어 있습니다.

**제 5조 (등록 정보의 변경)**

사용자가 자신의 등록 정보를 변경하면, 변경 사항들은 회사가 정한 별도의 방법을 통해 신속하게 반영됩니다. 또한, 본사는 사용자가 등록 정보 변경을 지연함에서 생기는 어떤 불이익이나 손해에 대해 책임지지 않습니다.

**제 6조 (서비스 사용 기간)**

1. 사용자가 서비스를 사용하도록 허용된 시간 기간 (이하 “사용 기간”이라 합니다.)시작일부터 (이하 “사용 월”이라 합니다.) 30일 기준으로 한 달이 산출됩니다. (e.g.,시작 날짜가 1월 1일인 경우, 다음 시작일은 1월 31일입니다.)

2. 사용 기간은 사용 요금의 지불을 통해 갱신됩니다. 또한, 사용 요금은 제7조에서 규정된 방법을 사용하여 지급합니다.

**제 7조 (사용 요금 및 지불 방법)**

1. 사용자는 회사의 서비스를 이용하는 대가로 회사가 별도로 지정하고 있는 서비스 이용 요금을 지불해야 합니다. 또한, 사용자는 소비세, 세금의 다른 유형과 사용 요금에 적용되는 추가 세금에 대한 책임을 집니다.

2. 사용자는 KG 이니시스를 통하여 서비스 이용 요금에 대한 지불을 해야 합니다.

3. 서비스 사용 갱신을 위하여 사용자는 다음 달에 대한 사용 요금을 지불해야 합니다. 사용자의 서비스 사용 기간은 약관 제 13조에 따라 회원이 탈퇴하지 않는 경우 매달 같은 요금 조건으로 갱신됩니다. 또한, 약관 제 2항에 규정된 바와 같이,다음 사용 달에 대한 사용 요금은 해당 달의 이용 기간 종료 전에 지불되어야 합니다.

4. 정기 수강권 서비스의 사용 요금은 매월 1개월(30일 기준)의 사용 기간을 기준으로 청구됩니다. 또한, 이미 본사에 지불된 사용 요금은 별도로 규정된 환불 규정을 따릅니다.

(고객센터 > FAQ(https://engoo.co.kr/faq) > 결제문의 > 환불 관련 항목)

5. 한 달(30일 기준)을 초과하는 장기 계약의 경우에는 별도로 규정된 환불 규정을 따릅니다.

(고객센터 > FAQ(https://engoo.co.kr/faq) > 결제문의 > 환불 관련 항목)

**제 8조 (무료 수업)**

1. 서비스 회원 등록을 완료한 날부터, 사용자는 회사가 정한 별도의 규정을 따라 무료 체험 수업에 참여할 수 있습니다.

2. 사용자는 무료 수업을 체험하는 동안에도 이용 약관을 준수할 의무가 있습니다.

3. 본사는 동일 인물이 무료로 수업을 체험하기 위해 복수의 계정을 만들거나, 기타 부적절한 목적으로 복수의 계정을 만든 것으로 판단하는 경우 (부적절한 것으로 판단되는 모든 계정들에 적용됨.) 회사는 이와 같은 계정들로 무료 수업에 참여하는 것을 거부할 수 있습니다.

**제 9조 (수업)**

1. 수업은 25분 동안 진행됩니다. 달리 명시되지 않는 한, 수업 기간은 어떠한 이유로도 변경되거나 중단되지 않습니다.

2. 사용자가 수업 시간 이후부터 회사, 또는 담당 강사로부터의 전화를 15분간 받지 않으실 경우 (이하 “담당 강사” 라고 합니다.), 회사는 사용자가 수업을 놓친 것으로 간주하며 수업을 종료할 수 있습니다.

3. 사용자가 반복적으로 예약한 수업에 사전 통보 없이 참석하지 않을 경우 본사는 회원에게 수업 참여를 촉구하는 알림을 보낼 수 있습니다.

4. 본사는 회원들의 사유와 관계 없이 놓친 수업에 대한 보상이나 보강을 제공하지 않습니다.

**제 10조 (수업 예약)**

1. 최소 15분 전까지 수업의 예약이 가능합니다.

2. 예약을 완료한 후, 회원은 회사가 별도로 웹사이트에 규정해 놓은 과정을 통하여 최소 30분 전까지 수업 예약의 취소가 가능합니다.

3. 회원은 최대 6일 후의 수업을 예약할 수 있습니다. 최대로 예약할 수 있는 수업의 횟수는 회원이 구입한 수강권에 따라 달라질 수 있습니다.

4. 회원이 예약이 웹사이트에 반영되면, 수업의 예약이 성공적으로 이루어진 것으로 간주됩니다.

5. 회사는 해당 강사의 피치 못할 이유로 수업이 정상적으로 진행될 수 없을 경우,회원이 예약한 수업을 취소할 수 있습니다. 이러한 사유로 수업이 취소될 경우,회원은 이 조항에 따라 회사로부터 강의 교환권의 보상을 받을 수 있습니다.

**제 11조 (금지된 행동)**

1. 회원은 수업 중 혹은 기타 서비스 이용 시 아래에 명시된 행동들에 제한을 받습니다.

  (1) 다른 이에게 서비스 이용 권한을 이전, 이름 변경 등을 통해 양도하는 것

  (2) 권리 이전, 대여 혹은 비밀번호와 같은 정보를 제 3자에게 제공하거나 제 3자가 이용하도록 허용하는 것

  (3) 회사, 교수진 혹은 제 3자에게 그들의 명예, 신용, 저작권, 특허권,실용신안권, 상표, 초상권 혹은 사생활 침해를 일으킨 경우

  (4) 불법적인 행동 혹은 공공질서와 사회 도덕에 반하는 행위

  (5) 서비스 운영에 방해가 되는 행동

  (6) 상업적인 목적으로 서비스를 이용하거나 이를 준비하는 행위

  (7) 다른 사용자 혹은 강사들의 불법적인 행동을 장려하거나 하게끔 유도하는 행위

  (8) 다른 사용자 혹은 강사들에게 물질적/정신적인 피해 및 불편을 야기하는 행위

  (9) 범죄 행위 혹은 범죄 행위와 관련된 기타 행위

  (10) 강사들에게 성희롱을 하는 등 괴롭히는 행위 혹은 기타 수업 진행을 방해하는 부적절한 행동

  (11) 음주 상태로 수업에 참석하는 행위

  (12) 강사들에게 불편함과 당혹감을 줄 수 있는 행위와 속옷바람 등의 과한 노출

  (13) 회사에게 사전 허가를 받지 않고 강의 자료, 이미지, 영상, 녹음 자료 등을 배포하는 행위

  (14) 일반 규정으로 회사가 밝히지 않는 기밀 정보를 요청하는 행위;교사진들의 고용 조건, 콜 센터의 위치, 인터넷 연결에 대한 정보 등

  (15) 교사진을 상대로 한 종교, 정치 단체, 다단계 등에 관한 호객 행위

  (16) 교사진들과 개인적으로 연락을 취하고자 하는 행위; 전자 메일을 포함하는 온/오프라인, 직/간접적인 방법

  (17) 본사의 강사들에게 다른 서비스 혹은 경쟁업체로 유인하거나, 이직을 장려하는 행위

  (18) 본사 혹은 강사진들에게 폭력적인 언어나 행동, 기타 서비스 운영을 방해하기 위한 행위

  (19) 등록하지 않은 사람들에게 자신의 계정을 사용할 것을 용인하는 행위

  (20) 복수의 계정을 등록하는 행위

  (21) 회사의 승인 없이 등록하지 않은 사용자가 수업에 참여하는 것을 허용하는 행위

  (22) (1)-(21)에 준하여 정상적인 서비스 제공을 어렵게 하는 기타 모든 행위

2. 본사는 본사의 재량에 따라, 사용자가 위 조항들에 명시된 금지된 행위를 하였는지의 여부를 결정할 수 있습니다. 뿐만 아니라, 본사에게는 이 조항에 관하여 내린 결정에 대한 설명을 할 의무가 없음을 명시합니다.

3. 본사는 극도로 의무를 등한시한 경우를 제외하고, 위 조항에 따른 결정으로 인해 발생하는 불편이나 피해에 대한 책임을 지지 않습니다.

4. 사용자들은 조항 1의 위반으로 인해 본사나 제 3자에게 발생하는 피해에 대한 법적인 책임을 집니다. 이는 사용자가 회원권을 취소하였을 시에도 적용이 됩니다.

**제 12조 (서비스 보류, 중단, 정지, 등록 취소 등)**

1. 서비스가 제공되고 있는 여건에 관계 없이 본사의 귀책 사유가 없는 경우 본사는 아래의 조항들이 사용자에게 적용이 된다고 여겨지면, 위반 사항에 대해 시정 요구를 할 수 있으며 시정 요구에도 불구하고 시정되지 않을 경우, 본사에게는 아래 사유로 해당 사용자의 구독권을 보류, 중단, 정지, 혹은 등록 취소를 할 권한이 있습니다.

  (1) 제9조 제3항에 의거하여 사용자에게서 경고 및 유사 의사소통에도 불구하고 개선될 여지가 보이지 않다고 여겨질 시

  (2) 사용자가 제11조 제1항에 명시된 금지된 행위를 보였을 시

  (3) 사용자가 본 이용 약관에 명시된 규정들을 위반했을 시

  (4) 본 서비스를 이용함에 있어 사용자가 본사나 혹은 교사에게서 주어진 지침을 따르지 않았을 시

  (5) 기타 이유로 본사 측에서 사용자가 서비스를 부적절하게 이용하였다고 여길 시

  (6) 다만, 사용자가 제11조 1-3항, 1-6항, 1-9항, 1-10항, 1-11항, 1-12항에 해당하는 금지된 행동을 했다고 판단되는 경우, 본사에게는 해당 사용자의 구독권을 시정 요구 없이 즉시 중단, 정지 혹은 등록 취소를 할 권한이 있습니다.

2. 위 조항에 명시된 이유들로 인해 사용자가 정지 당했을 경우, 사용자는 본사로부터 이용한 서비스 부분에 대해 제 7조 (사용 요금 및 지불 방법)에 따라 환불 받을 수 있습니다.

3. 제1항에 명시된 이유들로 인해 사용자가 정지 당했을 경우, 본사에게는 사용자가 정지로 인해 입은 피해나 불편에 대한 책임이 없습니다.

**제 13조 (회원권 취소)**

1. 사용자는 본사 측에서 명시한 별도의 절차에 따라 회원권 취소를 요청할 수 있습니다. 취소 절차에 아무런 문제가 없다는 전제 하에, 사용자는 당월 말에 서비스를 이용할 권한을 상실함과 동시에 회원권이 취소됩니다. 아울러 본사가 사용자의 취소 요청을 확인 후 취소 확인 이메일을 발송함과 동시에 취소 절차는 완료되는 것으로 정의합니다.

2. 취소 요청은 서비스 이용 당월 시작 전날까지 접수되어야 합니다. 해당 기간 내에 요청이 접수되지 않은 경우, 당월 후의 달부터 회원권이 취소됩니다.

3. 사용자의 회원권이 성공적으로 취소됨과 동시에 사용자는 서비스에 대한 모든 권한을 상실하며 본사에 대한 클레임을 걸 수 없게 됩니다.

4. 사용자의 서비스 이용 행위로 인하여 본사나 제 3자에게 피해가 발생했을 경우,해당 사용자에게는 회원권이 취소 되었음에도 불구하고 피해에 대한 책임이 있습니다.

**제 14조 (본사 통지)**

1. 본사는 사용자가 엔구 회원으로 가입 시 등록한 이메일 주소 (이하 “지정된 이메일 주소”)로 서비스에 관한 통지를 보냅니다. 아울러 이메일을 보낸 시점이 곧 해당 통지들이 수신자에게 전달되었다고 정의합니다.

2. 본사는 사용자들이 항상 지정된 이메일 주소로 이메일을 받을 수 있음을 간주합니다.

3. 사용자가 이메일 주소를 변경할 시, 변경사항을 최대한 빨리 등록할 의무가 있습니다. 아울러 본사는 사용자가 이메일 주소 변경을 통지하지 않음으로써 발생하는 불편이나 피해에 대한 책임을 지지 않습니다.

**제 15조 (서비스 중지/종료)**

1. 본사는 본사의 재량에 따라 아래에 명시된 이유에 한해 사용자들에게 웹사이트나 지정된 이메일 주소로 사전 통보를 함으로써 서비스를 중지하거나 종료시킬 수 있습니다. 불가피한 상황에는 서비스가 사전 통보 없이 중지될 수 있습니다.

  (1) 내부적 및 외부적 정치 상황, 자연 재해, 가동상의 서버에 있는 유지 문제, 혹은 기타 불가피한 이유로 인해 서비스 제공이 어려워졌을 시

  (2) 필리핀의 국가 공휴일 시 (성주간, 성탄절 등)

2. 위 조항에 명시된 이유들로 인해 수강 가능한 수업의 수가 감소하였을 때,본사는 해당 상황에 대해 웹사이트나 이메일로 사용자들에게 통보를 할 의무가 있습니다. 사용자들이 7일 이내에 계약해지의 의사표시를 하지 않을 경우 이에 대하여 동의한 것으로 간주합니다.

3. 본사는 본사에 책임이 없는 상태에서 서비스 중단 및 종료로 인해 사용자 및 제3자에게 발생한 피해와 불편에 대한 책임을 지지 않습니다.

**제 16조 (사용자 책임)**

1. 회원들은 서비스 이용과 그 결과에 대한 전적인 책임을 가지고 있습니다.

2. 회원이 서비스를 이용하며 회사, 회사의 직원, 교수진, 다른 사용자 혹은 제3자에게 피해를 가했을 경우 (회사, 회사의 직원, 교수진, 다른 사용자 혹은 제3자가 이용 약관에 규정된 의무를 다하지 않은 회원으로부터 손해를 입었을 경우 포함), 회원은 이에 대한 보상과 책임을 질 의무가 있습니다.

**제 17조 (저작권과 소유)**

1. 이미지, 사진, 음성 녹음, 상표, 로고, 글과 서비스와 관련된 모든 매체들의 저작권과 소유권 (이하 “저작권”이라고 합니다)은 모두 본사에 귀속됩니다.회원들은 본사의 저작권에 위반할 수 없습니다. 회원들은 인쇄, 업로드, 잡지 혹은 웹사이트에 업로드를 하거나, 제 3자에게 배포할 수 없습니다.

2. 만일 회원이 선행 조항을 위반한 것으로 간주될 경우, 본사는 일본의 저작권법,상표법 혹은 기타 법을 통하여 필요한 조치(경고장 발송, 피해 보상 청구, 가처분 신청 등)를 취할 수 있습니다.

**제 18조 (권리 포기)**

사용자는 본사에게는 아래에 명시된 상황들로 인해 발생한 피해나 불편에 대한 책임이 없음을 사전 동의합니다.

(1) 사용자가 아래 이유들로 인해 서비스를 만족스럽게 이용하지 못했을 때:

1. 사용자가 희망하는 시간대에 수업을 예약하지 못했을 때

2. 사용자가 희망하는 강사와 수업을 예약하지 못했을 때

3. 수업이 정전, 의사소통의 문제, 그리고 그 외의 이슈들로 인해 중단되었을 때

4. 사용자의 메세지나 정보에 대한 불법적인 접근 및 수정 혹은 그 외의 제3자로 인한 불법적인 행위가 감지되었을 때

(2) 서비스에서 제공되는 수업에 대한 교육적인 효과, 타당성, 정확성, 진실성 및 기타 사항

(3) 서비스에 관련하여 본사 측에서 소개하거나 추천한, 타사에서 제공된 강의 교재들의 효과, 타당성, 안정성 및 정확성

(4) 이 이용약관의 제16조 제5항에 의거하여, 사용자가 스스로의 책임 하에 전송 받은 파일에 있는 바이러스로 인해 피해를 입었을 시

(5) 사용자가 본인의 부주의로 인해 서비스를 이용하는 것이 불가하였을 시(비밀번호 분실 및 상실 등)

(6) 본사의 웹사이트에서 제공되는 링크의 완전함, 정확성, 현대성, 안전성 등

(7) 본사의 웹사이트에 게재된 타 사이트들의 컨텐츠 및 이용.

**제 19조 (비 보장 조항)**

사용자들은 본사가 아래의 조항들에 관하여 어떠한 보장도 하지 않는다고 사전에 동의합니다:

(1) 사용자가 희망하는 시간대에 수업 예약 가능 여부

(2) 사용자가 희망하는 강사의 수업 예약 가능 여부

(3) 본 서비스에서 제공하는 수업의 교육적인 효과, 타당성, 정확성, 진실성 등

(4) 서비스 이용에 적합한 환경 아래 어떠한 이슈 없이 서비스를 제공할 수 있는 본사의 능력

(5) 서비스 이용에 관련한 소프트웨어, 파일들, 그리고 그 외의 요소들에 대한 안전성

(6) 본사의 웹사이트에 게재된 링크 및 정보의 완성도, 정확성, 현대성, 안정성 등

(7) 본사의 웹사이트나 본사의 웹사이트로 링크가 되는 타 사이트에 게재된 컨텐츠 및 컨텐츠 이용에 대한 정확성과 안정성 등

**제 20조 (기업 이전)**

본사가 제 3자에게 서비스를 이전할 시, 이용 약관을 기초로 본사는 제 3자에게 회원 등록 정보와 기타 정보들을 포함하여 모든 권리와 의무를 이전할 수 있는 것으로 간주합니다. 개인정보를 이전할 경우 본사는 사용자들에게 개인정보 이전 사실, 개인정보를 이전받는 자의 성명, 주소, 전화번호 및 그 밖의 연락처, 개인정보 이전을 원하지 않을 경우 동의 철회 방법 및 절차를 인터넷 홈페이지를 통해 고지합니다.

**제 21조 (서비스 날짜/시간 표시)**

1. 서비스 사용 시작일, 사용(월) 시작 날짜, 수수료들, 신청들 등, 모든 날짜와 시간은 한국을 기준으로 표시됩니다. (GMT +9:00)

2. 서비스 내의 모든 시간 계산은 회사의 시간을 기초로 합니다.

**제 22조 (정부법과 독점적 관할권 법원)**

1. 본 이용약관에 명시되지 아니하거나 해석에 이견이 있는 사항에 관하여 관련 법규 및 일반 상관례에 따라 협의 조정함을 원칙으로 합니다.

2. 본 이용약관과 관련하여 분쟁이 발생하는 경우 소송관할은 서울중앙지방법원으로 합니다.`;

export const KoreanTermsPersonalInfo = `**개인정보 처리방침**

1.     개인정보 처리방침

DMM.com (주) (이하 “본사”, “저희”) 은 Engoo (이하 “본 서비스”) 온라인 영어 회화 서비스의 운영에 대한 사회적 책임의 중요성을 인식하여 늘 개인 정보를 적절하게 관리하기 위해 노력하고 있습니다.

여기 개인정보 처리방침은 개인 정보의 적절한 처리 및 저희의 기업 철학 및 경영 활동에 상응하는 자발적 규칙의 방법, 개인 정보의 보호에 관한 법률 (이하 “개인 정보 보호 준수 법”) 준수, 한국의 개인정보 관련 법률 준수, 그리고 개인 정보 보호를 강화시키기 위해 게재합니다.

저희 모든 임직원은 개인 정보 보호 준수 프로그램 (본 정책, 사내 규정 등) 에 따라, 그리고 이하 정책에 의거하여 개인 정보를 보호하기 위해 최선을 다할 것입니다.

1.1. 개인 정보 보호 시스템

저희는 개인 정보를 적절하게 관리하기 위해 매니저와 사내 시스템을 구축하여 역할과 책임을 명시하겠습니다. 저희는 암호화 및 다른 방법들을 통하여 본 서비스를 이용하는 회원님들의 개인 정보를 보호하기 위해 최선을 다할 것입니다.

1.2. 개인 정보의 안전

저희는 공인되지 않은 접근, 절도, 남용으로 인한 개인 정보의 실종, 파괴, 변경, 누출 등으로부터 개인 정보를 보호하기 위해 필요한 예방책 및 개선책을 투입할 것입니다. 저희는 회원님의 동의가 있지 않은 한 개인 정보의 누출 및 제공을 방지하기 위해 개인정보 관리를 수행하는 타사와 계약을 맺습니다.

1.3. 개인 정보 관련 법과 규정 준수

저희는 “개인정보 보호법” 및 "정보통신망 이용촉진 및 정보보호 등에 관한 법률” 등 개인 정보 보호에 관한 규정들을 준수합니다.

1.4. 준수 프로그램의 지속적인 개선

저희는 저희의 사업 활동과 법적 그리고 사회적 환경 그리고 비즈니스의 IT 환경의 변화에 발맞춰 저희의 개인 정보 보호 준수 프로그램을 지속적으로 검토하고 개선시킬 것입니다.
 

2.     개인 정보 취급자의 이름

DMM.com (주)


3.     개인 정보 수집에 관한 사항

저희는 본 서비스 제공을 위하여 아래의 개인 정보를 수집할 것입니다. 뿐만 아니라, 아래 정보는 예시이며 정보의 본질에 따라 해당 개인 정보에 상응하지 않을 수도 있습니다.

3.1. 회원님이 제공하는 정보
  - 이름, 성별, 전화번호, 이메일 주소, 연락처, 직업, 제휴사 코드, 결제 정보
  - 결제 카드 정보
  - 등록과 변경 요청에 대한 정보
  - 배송 과정 및 다양한 상품의 배달에 관한 정보
  - 다양한 상품과 서비스의 구매에 관한 정보
  - 고객센터에 접수한 각종 문의사항에 관한 정보
  - 회원 등록에 관한 정보
  - 회원님이 자발적으로 등록한 아이디, 성별, 직업, 관심분야, 그리고 기타 정보
  
3.2. 본 서비스 사용에 관련하여 수집된 정보
- 본인 확인에 적합한 선결제, 입찰, 다양한 상품과 서비스의 구매에 관련된 결제내역의 정보, 그리고 양도 및 기타 결제 요청에 관한 내역 정보
- 본사의 이메일 소식지 구독에 관한 정보
- 전화, 이메일 등을 통하여 본사에 질문하거나, 설문조사 및 캠페인에 응답하거나 본 서비스를 검토한 구두 및 서면의 진술에 대한 정보
  
3.3. 본사의 웹사이트를 방문 시 자동으로 수집되는 정보
- IP 주소 및 도메인 이름
- 브라우저 종류 및 버전, 운영 시스템 및 버전, 사용된 언어 및 장소
- 장치 정보 (PC, 모바일 폰, 스마트폰, 통신사, 모델명, 특정 식별자 정보 등)

(1)-(3) 의 경우에 수집된 정보는 회원님의 개인 정보에 한하며 저희가 본 서비스 공급에 있어 필수적으로 필요한 최소한의 정보임을 명시합니다.
뿐만 아니라, 회원님의 원활한 서비스 이용을 위하여 저희 측에서 추가 정보를 요청할 수 있으나, 회원님의 개인 정보 제공에 대한 책임은 회원님이 집니다.
  
3.4. 쿠키

쿠키는 원활한 인터넷 이용을 위하여 회원님이 현재까지 방문한 페이지 등과 같은 정보를 기록하는 파일입니다. 본사는 회원님의 쾌적한 웹사이트 이용을 위해 아래의 목적들을 위하여 쿠키를 사용합니다.
- DMM 및 Engoo 에 저장된 등록 정보를 접근하고 마이페이지와 같은 로그인 시 개별화된 정보를 제공하기 위한 목적
- 로그인 후 회원님이 구입하신 상품과 서비스를 전시하기 위한 목적
- DMM 및 Engoo 의 트래픽과 회원수 파악을 위한 목적
- DMM 및 Engoo 의 컨텐츠와 서비스 향상을 위한 목적
- 면허증 입증 및 다운로드 받은 파일 정보 확인을 위한 목적
쿠키는 회원님의 개인권리를 침해하지 않습니다. 뿐만 아니라, 회원님의 개인 정보를 수집하기 위해서 절대 쓰이지 않습니다. 본 서비스를 이용 시 늘 쿠키 설정이 켜져 있도록 확인해주시기 바랍니다.
  
3.5. 외주 트래킹 시스템

본사는 회원들의 이용 트렌드를 분석하기 위해 외주 시스템들을 사용합니다 (Adobe SiteCatalyst, Google Analytics, ClickTale).
  
3.6. 본사는 다음과 같은 방법으로 개인정보를 수집합니다.

홈페이지를 통한 회원가입, 관계 전자상거래 Site
  

4.     보유된 개인 정보 이용 목적에 관련된 사항들

본사의 보유된 개인 정보 이용의 목적은 아래와 같이 명시되어 있습니다. 회원님이 명시한 수신인 정보와 기타 유사 정보, 그리고 회원님을 제외한 개인에게 속하는 정보는 아래 명시된 목적을 위해서만 사용될 것입니다. 본사가 특정 기능들을 외주 업체에 위임 시, 본사는 예방책들을 수행한 후, 특정 목적을 이루기 위하여 해당 외주 업체에 회원님의 개인 정보를 전달할 수 있습니다. 본사가 개인 정보에 관련된 기능이나 제공을 본사의 기준에 적합한 외주 업체에 전달 시, 본사는 개인 정보의 보호를 필수로 요청하는 계약서 및 그에 상응하는 적합한 규제들을 제작 및 관리할 것입니다.

보유된 개인 정보에 관한 개인 정보 이용의 목적 및 서식

4.1. 이름

개인적 문의, 상품 배송, 결제, 고객 지원, 공인되지 않은 정보 이용에 대한 예방책 및 조사 및 Engoo 상품 배송을 위한 배송 주소를 판매자에게 제공, 본사의 웹사이트에 있는 변경에 관한 공지, 본사의 웹사이트에 새로운 서비스의 소개, 결제에 필요한 기타 업무, 본사 및 타사의 광고 전달 및 발송, 타사에 제공
  
4.2. 주소

개인적 문의, 상품 배송, 결제, 고객 지원, 공인되지 않은 정보 이용에 대한 예방책 및 조사 및 Engoo 상품 배송을 위한 배송 주소를 판매자에게 제공, 본사의 웹사이트에 있는 변경에 관한 공지, 본사의 웹사이트에 새로운 서비스의 소개, 결제에 필요한 기타 업무, 본사 및 타사의 광고 전달 및 발송, 타사에 제공
  
4.3. 전화번호

개인적 문의, 상품 배송, 결제, 고객 지원, 공인되지 않은 정보 이용에 대한 예방책 및 조사 및 Engoo 상품 배송을 위한 배송 주소를 판매자에게 제공, 본사의 웹사이트에 있는 변경에 관한 공지, 본사의 웹사이트에 새로운 서비스의 소개, 결제에 필요한 기타 업무, 본사 및 타사의 광고 전달 및 발송, 타사에 제공
  
4.4. 이메일 주소

개인적 문의, 상품 배송, 결제, 고객 지원, 공인되지 않은 정보 이용에 대한 예방책 및 조사 및 Engoo 상품 배송을 위한 배송 주소를 판매자에게 제공, 본사의 웹사이트에 있는 변경에 관한 공지, 본사의 웹사이트에 새로운 서비스의 소개, 결제에 필요한 기타 업무, 본사 및 타사의 광고 전달 및 발송, 타사에 제공
  
4.5. 신용카드 정보 (이름, 번호, 유효기간)

개인적 문의, 상품 배송, 결제, 고객 지원, 공인되지 않은 정보 이용에 대한 예방책 및 조사 및 Engoo 상품 배송을 위한 배송 주소를 판매자에게 제공, 본사의 웹사이트에 있는 변경에 관한 공지
  
4.6. 은행 계좌 정보 (이름, 계좌번호 등)

광고 비용 지불, 보수 등, 고객 지원, 결제에 필요한 기타 업무 실적
  
4.7. 신원 확인 및 나이 확인을 위한 공식 서류들 (운전 면허증, 보험증 등)
 
신원 확인, 이름 확인
  
4.8. 결제 세부사항

상품 배송, 결제, 고객 지원, 공인되지 않은 정보 이용에 대한 예방책 및 수색, 결제에 필요한 기타 업무 실적, 타사에 제공
  
4.9. IP 주소

공인되지 않은 정보 이용에 대한 예방책 및 조사, 회원님의 질문에 대한 응답이나 회원님에 대한 본사의 질문
  
4.10. 사용자 에이전트 (사용된 브라우저, 장치 정보 등)

공인되지 않은 정보 이용에 대한 예방책 및 조사, 회원님의 질문에 대한 응답이나 회원님에 대한 본사의 질문
  
4.11. 회원님이 자발적으로 입력한 주소

고객 신원 확인, 등록 컨텐츠의 위임, 타사에 제공
  
4.12. 회원님이 본사의 웹사이트를 방문 시 자동으로 수집되는 정보

로그인과 로그아웃 시 사용자의 신원 확인, 서비스 이행 시 전이된 회원 정보, 로그인 시도 횟수 감지, 샘플 영상의 사용을 허락하는지에 대한 결정, 공인되지 않은 정보 이용에 대한 예방책 및 수색
  
4.13. 회원님의 사전 동의 하에 제공된 기타 정보

서비스 사용 분석, 서비스 향상, 새로운 서비스 구축에 대한 참조, 그리고 정보 수집 시 명시된 목적들에 한함
본사는 기타 개인 서비스 및 유사 서비스를 계획함에 있어 위에 명시되지 않은 목적을 위해서 개인 정보를 수집 및 이용할 수 있습니다. 이러한 경우에 본사는 회원님의 동의를 얻은 후 이용 목적을 개인 서비스의 페이지 등에 명시하겠습니다.

 
5. 개인정보의 처리 및 보유기간, 개인정보의 파기절차 및 파기방법

5.1. 본사는 회원님의 탈퇴시까지 회원님의 개인정보를 보유합니다. 단, 본사는 회원님의 탈퇴 후에도 관련 법령의 규정에 따라 다음과 같이 일정 기간 회원님의 개인정보를 보유할 수 있습니다.
  - 계약 또는 청약철회 등에 관한 기록: 5년 (전자상거래등에서의 소비자보호에 관한 법률)
  - 대금결제 및 재화 등의 공급에 관한 기록: 5년 (전자상거래등에서의 소비자보호에 관한 법률)
  - 소비자의 불만 또는 분쟁처리에 관한 기록: 3년 (전자상거래등에서의 소비자보호에 관한 법률)
  - 신용정보의 수집/처리 및 이용 등에 관한 기록: 3년 (신용정보의 이용 및 보호에 관한 법률)
  - 통신비밀보호법에 따른 통신사실확인자료: 3개월

5.2. 개인정보 보유기간이 경과된 경우 본사는 지체 없이 개인정보를 파기합니다. 단, 관계 법령에 의하여 일정기간 보존하여야 할 개인정보는 해당 기간이 경과한 후 지체 없이 파기됩니다. 개인정보를 파기할 때에는 재생할 수 없는 기술적 방법으로 삭제합니다.


6.     개인 정보의 공개 요청 및 절차에 관련된 사항들

본사는 아래와 같이 문의 절차 (이하 “문의 지침”)를 구축하였으며, 회원님이나 회원님의 대리인에게서 개인 정보의 공개, 수정, 이용 중단, 목적에 관한 질문 등 (이하 “공개 요청 등”) 을 받았을 시, 본사는 이 문의 지침에 의거하여 응대하도록 하겠습니다. 뿐만 아니라, 문의 지침에 순응하지 않는 요청들에 대해 대답하지 않을 권한이 본사에 있음을 참조해주시기 바랍니다. 문의 사항의 접수 등에 대한 정보를 알고 싶으시다면 엔구 고객센터에 연락 주십시오.

이메일: info.kr@engoo.com


7.     제 3자에게 개인 정보를 제공하는 것과 관련된 사항들

본사는 회원님의 사전 동의 없이 개인 정보를 제 3자에게 제공하지 않으나, 아래의 상황에는 해당 정보들이 제공될 수 있습니다 (개인 정보 보호 법 Art. 23 Secs 2 and 3)

7.1. 법과 규제에 의거한 요청을 본사가 받았을 때
7.2. 개인 정보 제공을 거부함으로써 공공의 이익에 상반되는 문제점들이 일어날 때, 그리고 회원님의 동의를 구하기가 어려울 때
7.3. 국가 정부 기관, 지역 공공 기관, 혹은 계약자 등이 법적으로 필요한 기능들을 수행함에 있어 정보 이용 및 본사의 협력이 필요할 때, 그리고 회원님의 동의를 구하는 것이 해당 기능 수행을 지연시킬 때
7.4. 본사의 법적 권리를 행사하는 것이 필요할 때
 

8. 개인정보의 취급위탁

본사는 다음과 같이 개인정보 취급업무를 위탁하고 있습니다.

**수탁자: **KG 이니시스
**목적: **결제 서비스

**수탁자: **엔구코리아
**목적: **개인정보의 수집


9. 개인정보의 국외 이전

본사는 다음과 같이 개인정보를 국외로 이전하고 있습니다.

**이전되는 개인정보 항목**
이름, 성별, 이메일(회원 ID), 비밀번호, 전화번호, 직업, 추천인, 제휴사 코드
  
**이전국가**
일본
  
**이전일시·이전방법**
회원가입 즉시 서버로 전송
  
**담당자 연락처**
켄타로 사카네
engoo-security@dmm.com
  
**개인정보를 이전받는 자의 개인정보 이용 목적**
본인식별 및 본인의사 확인, 회원제 서비스 관리, 웹사이트 서비스 제공
  
**개인정보를 이전받는 자의 개인정보 보유·이용기간**
회원 탈퇴시까지


10. 이용자 및 법정대리인의 권리와 그 행사방법

10.1. 회원님 또는 만 14세 미만 회원의 법정 대리인은 언제든지 등록되어 있는 자신 혹은 당해 만14세 미만 아동의 개인정보를 조회하거나 수정할 수 있으며 탈퇴를 요청할 수도 있습니다.

10.2. 이용자 혹은 만 14세 미만 아동의 개인정보 조회, 수정을 위해서는 개인정보변경을, 탈퇴(동의 철회)를 위해서는 회원탈퇴를 클릭하여 본인 확인 절차를 거치신 후 직접 열람, 정정 또는 탈퇴가 가능합니다. 혹은 개인정보관리책임자에게 서면, 전화 또는 이메일로 연락하시면 지체 없이 조치하겠습니다.

10.3. 본사는 개인정보의 오류에 대한 정정 요청이 있는 경우 정정을 완료하기 전까지 당해 개인정보를 이용 또는 제공하지 않습니다. 만일 잘못된 개인정보를 제3자에게 이미 제공한 경우에는 정정 처리결과를 제3자에게 지체 없이 통지하여 정정이 이루어지도록 하겠습니다.

10.4. 본사는 회원님 혹은 만14세 미만 회원의 법정 대리인의 요청에 의해 해지 또는 삭제된 개인정보를 “6. 개인정보의 처리 및 보유기간, 개인정보의 파기절차 및 파기방법”에 명시된 바에 따라 처리하고 그 외의 용도로 열람 또는 이용할 수 없도록 처리하고 있습니다.


11.     기타 사항들

11.1 위에 명시된 규정들은 본 서비스에 적용됩니다.

11.2 본 서비스가 타 사이트에 회원님을 링크 시키면 해당 사이트에서 개인 정보 이용에 관하여 확인해 주시기 바랍니다.

11.3 본 사이트는 언제든 위에 명시된 사항들에 관하여 수정될 수 있으며, 적절한 검토 후 수정 사항들에 대한 공지사항이 게재될 것입니다.

11.4 기타 절차 등에 관한 질문이 있으시면 아래로 연락 주시기 바랍니다.
    엔구 고객 센터
    이메일: info.kr@engoo.com
    작성일: 2014년 5월 28일
    DMM.com (주)
    대리 감독자: Tatsuya Matsue
  
11.5 본사는 개인정보에 대한 의견수렴 및 불만처리를 담당하는 개인정보 관리책임자를 지정하고 있습니다. 개인정보 관리책임자는 다음과 같습니다.
    엔구 코리아 개인정보 보호책임자: 신명주 (연락처: 02-6261-1193)
    DMM 개인정보 보호책임자: 켄타로 사카네 (연락처: engoo-security@dmm.com)`;

export const KoreanTermsPersonalInfoUsage = `**개인정보 수집 · 이용 목적**

본인식별 및 본인의사 확인, 회원제 서비스 관리, 웹사이트 서비스 제공

**수집하는 개인정보의 항목**

이름, 성별, 이메일(회원ID), 비밀번호, 휴대전화번호

**개인정보 이전 국가**

일본

**이전 일시 · 이전 방법**

회원가입 즉시 서버로 전송

**개인정보의 보유 · 이용 기간**

회원 탈퇴시까지

**담당자 연락처**

engoo-security@dmm.com`;
/* eslint-enable max-len, no-trailing-spaces */
